import ModelService from './ModelService';
const modelService = new ModelService();

const model = 'resource-tracks';

export async function PostTrack(formData) {
  return modelService.PostModel(model, formData);
}
